/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base response structure for all API responses
 * @export
 * @interface BaseResponse
 */
export interface BaseResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof BaseResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof BaseResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the BaseResponse interface.
 */
export function instanceOfBaseResponse(value: object): value is BaseResponse {
    return true;
}

export function BaseResponseFromJSON(json: any): BaseResponse {
    return BaseResponseFromJSONTyped(json, false);
}

export function BaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function BaseResponseToJSON(json: any): BaseResponse {
    return BaseResponseToJSONTyped(json, false);
}

export function BaseResponseToJSONTyped(value?: BaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
    };
}

